import { getUserData } from "@/auth/utils";
import axios from "@axios";
import VueI18n from "@/libs/i18n";
import store from "@/store";

export const printActions = {
  async selectedPlantTonaj() {
    if (store.state.formulasModule.printWithPlantTonaj) {
      const selectedId = store.state.app.selectedPlantId;
      if (store.state.plantsModule.plantData.length > 0) {
        return (
          store.state.plantsModule.plantData.filter(
            (x) => x.id == selectedId
          )[0]?.tonaj ?? store.state.plantsModule.plantData[0]?.tonaj
        );
      } else return 1000;
    } else {
      return 1000;
    }
  },

  async printFormulaService(ctx, { formula, formulaid }) {
    var ext = "pdf";
    switch (formula.rasyon[0].raporcikti) {
      case "PDF":
        ext = "pdf";
        break;
      case "EXCEL":
        ext = "xlsx";
        break;
      case "WORD":
        ext = "docx";
        break;
      default:
        ext = "pdf";
        break;
    }

    const print = (downloadedFile) => {
      var downloadLink = document.createElement("a");
      downloadLink.target = "_blank";
      downloadLink.download = formula.rasyon[0].rasyonname + "." + ext;
      var blob = new Blob([downloadedFile.data], {
        type: "application/" + ext,
      });
      var URL = window.URL || window.webkitURL;
      var downloadUrl = URL.createObjectURL(blob);

      downloadLink.href = downloadUrl;

      document.body.appendChild(downloadLink);

      downloadLink.click();

      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadUrl);
      return blob;
    };

    // Get report ID based on report type
    let reportId = 1; // Default to Uretim
    switch (formula.rasyon[0].raportipi) {
      case "Uretim":
        reportId = 1;
        break;
      case "Detay":
        reportId = 7;
        break;
      case "Analiz":
        reportId = 8;
        break;
    }
    // Build the new payload structure
    const payload = {
      reportId: reportId,
      parameters: {
        formula: formula.rasyon[0].id.toString(),
        firstNote: formula.rasyon[0].not1 || "",
        tonaj: parseInt(formula.rasyon[0].tonaj) || 3500,
        isProduction: "",
        "logoShow.show": formula.rasyon[0].showcompanylogo || false,
        "companyNameShow.show": formula.rasyon[0].showcompanyname || false,
        "nutrient.title": "",
      },
      excel: {
        isExcel: formula.rasyon[0].raporcikti === "EXCEL",
        onlyTable: false,
      },
      data: {
        formula: {
          cozdu: formula.cozdu || true,
          rasyon: {
            id: formula.rasyon[0].id,
            code: formula.rasyon[0].code,
            rationname: formula.rasyon[0].rationname,
            fiyat: formula.rasyon[0].price || formula.rasyon[0].fiyat,
            oncekifiyat: formula.rasyon[0].price || formula.rasyon[0].fiyat,
            uretimfiyat: 0,
            ingredientid: null,
          },
          hammaddeler: formula.hammaddeler.map((x) => ({
            id: x.id,
            ikey: x.ikey,
            kod: x.kod || x.code,
            ingredientname: x.ingredientname,
            karisim: x.karisim,
            orjkarisim: x.karisim,
            min: x.min,
            max: x.max,
            aktif: x.aktif,
            stok: x.stok,
            price: x.price || x.fiyat,
            minproduction: 0,
            oncekikarisim: x.karisim,
            minfiyat: 0,
            maxfiyat: 0,
            onerilenkarisim: 0,
            onerilenfiyat: 0,
            uretimkarisim: 0,
            orjprice: x.price || x.fiyat,
            stockamount: null,
            itemtextcolor: "success",
            itembgcolor: "White",
          })),
          besinmaddeleri: formula.besinmaddeleri
            .filter((x) => x.print === true)
            .map((x) => ({
              id: x.id,
              nkey: x.nkey,
              kod: x.kod || x.code,
              nutrientname: x.nutrientname,
              birimadi: x.birimadi || x.birim,
              deger: x.deger,
              orjdeger: x.deger,
              uretimdeger: 0,
              oncekideger: x.deger,
              min: x.min,
              max: x.max,
              aktif: x.aktif,
              tip: "Gerçek",
              onerilendeger: 0,
              onerilenfiyat: 0,
              bmid1: 0,
              bmid2: 0,
              itemtextcolor: "success",
              itembgcolor: "White",
            })),
          yemToplami: 1000,
          calculation: "calculated",
        },
      },
    };

    // Add detail parameters for Detay report
    if (reportId === 7) {
      payload.parameters["ingredient.includeZero"] =
        formula.rasyon[0].showunused || false;
      payload.parameters["ingredient.min"] =
        formula.rasyon[0].showingminmax || false;
      payload.parameters["ingredient.max"] =
        formula.rasyon[0].showingminmax || false;
      payload.parameters["ingredient.price"] =
        formula.rasyon[0].showingredientprices || false;
      payload.parameters["nutrient.filter"] = true;
      payload.parameters["nutrient.min"] =
        formula.rasyon[0].shownutminmax || false;
      payload.parameters["nutrient.max"] =
        formula.rasyon[0].shownutminmax || false;
      payload.parameters["additionalValues.show"] = false;
      payload.parameters["additionalValues.filter"] = true;
      payload.parameters["productionCost.show"] =
        formula.rasyon[0].showprice || false;
    }

    // Add production parameters for Uretim report
    if (reportId === 1) {
      payload.parameters["checker_counter.value"] = 40;
      payload.parameters["checker_counter.show"] = true;
    }

    return await axios
      .post("https://www.yemyap.com/api/report/print", payload, {
        headers: {
          companyname: encodeURIComponent(getUserData().companyname || ""),
          plantname: encodeURIComponent(formula.rasyon[0].plantname || ""),
          currency: encodeURIComponent(formula.rasyon[0].currency || "TL"),
          symbolinfront: getUserData().symbolinfront ? "true" : "false",
          showcompanynameinreports: getUserData().showcompanynameinreports
            ? "true"
            : "false",
          showcompanylogoinreports: getUserData().showcompanylogoinreports
            ? "true"
            : "false",
          "Content-Type": "application/json",
        },
        responseType: "blob",
      })
      .then((response) => print(response))
      .catch((error) => {
        throw error;
      });
  },

  async printProdFormula(ctx, formula) {
    let hammaddeler = formula.hammaddeler;
    let besinmaddeleri = formula.besinmaddeleri;
    let _newformula = {};
    const plantTonaj = await ctx.dispatch("selectedPlantTonaj");
    _newformula = { ...formula };
    _newformula.hammaddeler = hammaddeler.map((x) => {
      delete x.id;
      return {
        id: x.id,
        ikey: x.ikey,
        code: x.kod,
        ingredientname: x.ingredientname,
        karisim: (x.karisim * plantTonaj) / 1000,
        fiyat: x.fiyat,
      };
    });
    var b = {};
    _newformula.besinmaddeleri = besinmaddeleri.map((x) => {
      return {
        id: x.id,
        code: x.kod,
        nkey: x.nkey,
        nutrientname: x.nutrientname,
        birimadi: x.birimadi,
        deger: x.deger,
      };
    });
    var isSuccess = await ctx.dispatch("printFormulaService", {
      formula: _newformula,
      formulaid: formula.rasyon[0].id,
    });
    if (typeof isSuccess == "object") {
      ctx.dispatch("toast", {
        msg: "successful",
        type: "saved",
        tur: "formula",
      });
      return isSuccess;
    } else {
      ctx.dispatch("toast", {
        msg: "unsuccessful",
        type: "notSaved",
        tur: "formula",
      });
    }
  },

  async printProdArchiveFormula(ctx, formula) {
    let hammaddeler = formula.hammaddeler;
    let besinmaddeleri = formula.besinmaddeleri;
    let _newformula = {};
    const plantTonaj = await ctx.dispatch("selectedPlantTonaj");
    _newformula = { ...formula };
    _newformula.hammaddeler = hammaddeler.map((x) => {
      delete x.id;
      return {
        id: x.id,
        ikey: x.ikey,
        code: x.kod,
        ingredientname: x.ingredientname,
        karisim: (x.karisim * plantTonaj) / 1000,
        fiyat: x.fiyat,
      };
    });
    _newformula.besinmaddeleri = besinmaddeleri.map((x) => {
      return {
        id: x.id,
        code: x.kod,
        nkey: x.nkey,
        nutrientname: x.besinmaddesi,
        birimadi: x.birimadi,
        deger: x.deger,
      };
    });
    var isSuccess = await ctx.dispatch("printFormulaService", {
      formula: _newformula,
      formulaid: formula.rasyon[0].id,
    });
    if (typeof isSuccess == "object") {
      ctx.dispatch("toast", {
        msg: "successful",
        type: "saved",
        tur: "formula",
      });
      return isSuccess;
    } else {
      ctx.dispatch("toast", {
        msg: "unsuccessful",
        type: "notSaved",
        tur: "formula",
      });
    }
  },

  async printIngredientNeedReport(ctx, formula) {
    let hammaddeler = formula.hammaddeler;
    let formuller = formula.formuller;
    let _newformula = {};
    const plantTonaj = await ctx.dispatch("selectedPlantTonaj");
    _newformula = { ...formula };

    _newformula.hammaddeler = hammaddeler
      .filter((x) => x.amount != 0)
      .map((x) => {
        delete x.id;
        return {
          Aciklama: x.ingredientname,
          Deger: x.amount?.toString() ?? "",
        };
      });
    _newformula.formuller = formuller
      .filter((x) => x.amount != 0)
      .map((x) => {
        return {
          Aciklama: x.rationname,
          Deger: x.amount?.toString() ?? "",
        };
      });
    _newformula.rasyon = formula.raporbilgileri;
    var isSuccess = await ctx.dispatch("printFormulaService", {
      formula: _newformula,
      formulaid: formula.raporbilgileri[0].id,
    });
    if (typeof isSuccess == "object") {
      ctx.dispatch("toast", {
        msg: "successful",
        type: "saved",
        tur: "formula",
      });
      return isSuccess;
    } else {
      ctx.dispatch("toast", {
        msg: "unsuccessful",
        type: "notSaved",
        tur: "formula",
      });
    }
  },

  async printFormula(ctx, formula) {
    let hammaddeler = formula.hammaddeler;
    let besinmaddeleri = formula.besinmaddeleri;
    let _newformula = {};
    const plantTonaj = await ctx.dispatch("selectedPlantTonaj");
    _newformula = { ...formula };

    _newformula.hammaddeler = hammaddeler.map((x) => {
      delete x.id;
      return {
        ikey: x.ikey,
        karisim:
          x.karisim == 0
            ? 0
            : parseFloat((x.karisim * 1000) / 1000) + 0.0000000000001,
        min: +parseFloat(x.min.toFixed(100)) + 0.0000000000001,
        max: +parseFloat(x.max.toFixed(100)) + 0.0000000000001,
        price: +parseFloat(x.price.toFixed(100)) + 0.0000000000001,
        aktif: x.aktif,
        stok: x.stok,
        maxfiyat: 0,
        ingredientname: x.ingredientname,
        code: x.kod,
      };
    });

    _newformula.besinmaddeleri = besinmaddeleri.map((x) => {
      return {
        nkey: x.nkey,
        deger: +parseFloat(x.deger.toFixed(100)) + 0.0000000000001,
        min: +parseFloat(x.min.toFixed(100)) + 0.0000000000001,
        max: +parseFloat(x.max.toFixed(100)) + 0.0000000000001,
        aktif: x.aktif,
        code: x.kod,
        nutrientname: x.nutrientname,
        birim: x.birimadi,
        print: x.print,
      };
    });
    var isSuccess = await ctx.dispatch("printFormulaService", {
      formula: _newformula,
      formulaid: formula.rasyon[0].id,
    });
    if (typeof isSuccess == "object") {
      ctx.dispatch("toast", {
        msg: "successful",
        type: "saved",
        tur: "formula",
      });
      return isSuccess;
    } else {
      ctx.dispatch("toast", {
        msg: "unsuccessful",
        type: "notSaved",
        tur: "formula",
      });
    }
  },
};
